import { getBaseApiPath } from '@/app/common/api/config';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';

const backlinkApi = createApi({
  reducerPath: 'backlinkNewApi',
  baseQuery: (...args) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['DomainStatus', 'BACKLINKS'],
  endpoints: () => ({})
});

// export const { } = backlinkApi;
export default backlinkApi;
